module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "left"
  }, [_c('a', {
    attrs: {
      "id": "page_ii"
    }
  }), _c('a', {
    attrs: {
      "id": "fm001"
    }
  }), _c('strong', [_vm._v("Previous books by Margaret J. Wheatley")])]), _vm._v(" "), _c('p', {
    staticClass: "leftt"
  }, [_vm._v("Turning to One Another")]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_vm._v("A Simpler Way (with Myron Kellner-Rogers)")]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_vm._v("Leadership and the New Science")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-098887f0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/fm001.vue
// module id = 60
// module chunks = 0